// Default style
export const defaultStyle = {
    option: (provided: any, state: any) => ({
        ...provided,
        color: "#2A2A2A",
        backgroundColor: state.isSelected ? "#F3F3F3" : "#FFFFFF",
        ":hover": {
            backgroundColor: state.isSelected ? "#F3F3F3" : "#DDE8F8",
            color: "#2A2A2A",
        },
        cursor: "pointer",
    }),
    menu: (provided: any) => ({
        ...provided,
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
        zIndex: 10,
    }),
    control: (provided: any, state: any) => ({
        ...provided,
        backgroundColor: "#FFFFFF",
        borderColor: "#cccccc",
        boxShadow: state.isFocused ? "0 0 0 1px #007a0b" : "none",
        "&:hover": {
            borderColor: "#007a0b",
        },
        transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    }),
    singleValue: (provided: any) => ({
        ...provided,
        color: "#2A2A2A",
    }),
    input: (provided: any) => ({
        ...provided,
        color: "#2A2A2A",
    }),
    valueContainer: (provided: any) => ({
        ...provided,
        padding: "2px 8px",
    }),
    indicatorSeparator: (provided: any) => ({
        ...provided,
        backgroundColor: "#cccccc",
    }),
    dropdownIndicator: (provided: any) => ({
        ...provided,
        color: "#666666",
        "&:hover": {
            color: "#007a0b",
        },
    }),
};


export const languageSelectStyle = {
    option: (provided: any, state: any) => ({
        ...provided,
        color: "#2A2A2A",
        backgroundColor: state.isSelected ? "#F3F3F3" : "#FFFFFF",
        ":hover": {
            backgroundColor: state.isSelected ? "#F3F3F3" : "#DDE8F8",
            color: "#2A2A2A",
        },
        cursor: "pointer"
    }),
    input: (provided: any) => ({
        ...provided,
        color: "#2A2A2A",
    }),
    menu: (provided: any) => ({
        ...provided,
        backgroundColor: "#FFFFFF", // white for light mode
        width: "fit-content",
        minWidth: "auto"
    }),
    control: (provided: any, state: any) => ({
        ...provided,
        padding: "0px 0px",
        color: "#2A2A2A",
        backgroundColor: "#FFFFFF", // white for light mode
        border: "none", // No border in light mode
        boxShadow: state.menuIsOpen ? "0 0 0 1px #007a0b" : "none",
        ":hover": {
            borderColor: state.menuIsOpen ? "#007a0b" : provided.borderColor,
        },
        width: "fit-content",
        height: "fit-content",
        cursor: "pointer"
    }),
    valueContainer: (provided: any) => ({
        ...provided,
        padding: "0px 0px 0px 8px ", // Adjust the padding to decrease space
    }),
    dropdownIndicator: (provided: any, state: any) => ({
        ...provided,
        color: "#666666",
        padding: "0px 8px 0px 1px",
        visibility: state.isDisabled ? "hidden" : "visible",
        ":hover": {
            color: "#007a0b",
        }
    }),
    indicatorsContainer: (provided: any) => ({
        ...provided,
        padding: "0px",
        margin: "0px",
    }),
    indicatorSeparator: (provided: any, state: any) => ({
        ...provided,
        visibility: "hidden",
    }),
    singleValue: (provided: any) => ({
        ...provided,
        color: "#6B7280"
    }),
};

export const timezoneStyle = {
    option: (provided: any, state: any) => ({
        ...provided,
        color: "#2A2A2A",
        backgroundColor: state.isSelected ? "#F3F3F3" : "#FFFFFF", // white for light mode
        ":hover": {
            backgroundColor: state.isSelected ? "#F3F3F3" : "#DDE8F8",
            color: "#2A2A2A",
        },
        cursor: "pointer"
    }),
    menu: (provided: any) => ({
        ...provided,
        backgroundColor: "#FFFFFF", // white for light mode
        width: "auto",
        right: 0
    }),
    control: (provided: any, state: any) => ({
        ...provided,
        padding: "0px 0px",
        color: "#2A2A2A",
        backgroundColor: "#FFFFFF", // white for light mode
        border: "none", // No border in light mode
        boxShadow: state.menuIsOpen ? "0 0 0 1px #007a0b" : "none",
        ":hover": {
            borderColor: state.menuIsOpen ? "#007a0b" : provided.borderColor,
        },
        width: "fit-content",
        height: "fit-content",
        cursor: "pointer"
    }),
    input: (provided: any) => ({
        ...provided,
        color: "#63666A", // Match surrounding text color
    }),
    valueContainer: (provided: any) => ({
        ...provided,
        padding: "0px 0px 0px 8px ", // Adjust the padding to decrease space
    }),
    dropdownIndicator: (provided: any, state: any) => ({
        ...provided,
        color: "#000000", // Black for light mode
        padding: "0px 8px 0px 1px",
        visibility: state.isDisabled ? "hidden" : "visible",
        ":hover": {
            color: "#000000", // Black for light mode
        }
    }),
    indicatorsContainer: (provided: any) => ({
        ...provided,
        padding: "0px",
        margin: "0px",
    }),
    indicatorSeparator: (provided: any, state: any) => ({
        ...provided,
        visibility: "hidden",
    }),
    singleValue: (provided: any) => ({
        ...provided,
        color: "#63666A"
    }),
}

export const activityLogStyle = {
    option: (provided: any, state: any) => ({
        ...provided,
        backgroundColor: state.isSelected ? "#e6f5e6" : "#FFFFFF",
        color: state.isSelected ? "#4a4a4a" : "#2A2A2A",
        cursor: "pointer",
        ":hover": {
            backgroundColor: state.isSelected ? "#e6f5e6" : "#f0f0f0",
        }
    }),
    control: (provided: any, state: any) => ({
        ...provided,
        backgroundColor: "#FFFFFF", // Explicitly set to white in light mode
        // Add green border when there's a selected value
        borderColor: state.hasValue ? "#007a0b" : "#cccccc",
        boxShadow: state.isFocused
            ? (state.hasValue ? "0 0 0 0.25px #007a0b" : "0 0 0 0.25px #cccccc")
            : "none",
        "&:hover": {
            borderColor: state.hasValue ? "#45a049" : "#bbbbbb", // Darker green on hover
        },
        transition: "border-color 0.2s ease, box-shadow 0.2s ease"
    }),
    valueContainer: (provided: any) => ({
        ...provided,
        padding: "4px 8px",
    }),
    singleValue: (provided: any) => ({
        ...provided,
        backgroundColor: "transparent", // No background on the container
        padding: 0,
        "& span": { // Style the inner text span
            padding: "2px 6px",
            borderRadius: "3px",
        }
    }),
    dropdownIndicator: (provided: any) => ({
        ...provided,
        color: '#666666',
        '&:hover': {
            color: '#007a0b',
        },
        padding: '8px',
        cursor: 'pointer'
    }),
    menu: (provided: any) => ({
        ...provided,
        backgroundColor: "#FFFFFF", // Explicitly set to white in light mode
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)"
    }),
    input: (provided: any) => ({
        ...provided,
        color: "#2A2A2A"
    }),
    indicatorSeparator: (provided: any) => ({
        ...provided,
        backgroundColor: "#cccccc"
    }),
}

export const connectionFilterStyle = {
    option: (provided: any, state: any) => ({
        ...provided,
        backgroundColor: state.isSelected ? "#e6f5e6" : "#FFFFFF",
        color: state.isSelected ? "#4a4a4a" : "#2A2A2A",
        cursor: "pointer",
        ":hover": {
            backgroundColor: state.isSelected ? "#e6f5e6" : "#f0f0f0",
        }
    }),
    control: (provided: any, state: any) => ({
        ...provided,
        minHeight: 38,
        height: 38,
        backgroundColor: "#FFFFFF",
        borderColor: state.hasValue ? "#007a0b" : "#cccccc",
        boxShadow: state.isFocused
            ? (state.hasValue ? "0 0 0 0.25px #007a0b" : "0 0 0 0.25px #cccccc")
            : "none",
        "&:hover": {
            borderColor: state.hasValue ? "#45a049" : "#bbbbbb",
        },
        transition: "border-color 0.2s ease, box-shadow 0.2s ease"
    }),
    valueContainer: (provided: any) => ({
        ...provided,
        padding: "0px 8px",
        height: 36,
        alignItems: 'center',
    }),
    menu: (provided: any) => ({
        ...provided,
        minWidth: 300,
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)"
    }),
    input: (provided: any) => ({
        ...provided,
        color: "#2A2A2A"
    }),
    indicatorSeparator: (provided: any) => ({
        ...provided,
        backgroundColor: "#cccccc"
    }),
    dropdownIndicator: (provided: any) => ({
        ...provided,
        color: '#666666',
        '&:hover': {
            color: '#007a0b',
        },
        padding: '8px',
        cursor: 'pointer'
    }),
}